/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_P1Inputs */

const en_guide_json_schema_s2_p1 = /** @type {(inputs: Guide_Json_Schema_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema uses keywords to define constraints. Here are the most commonly used ones:`)
};

const ko_guide_json_schema_s2_p1 = /** @type {(inputs: Guide_Json_Schema_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema는 제약 조건을 정의하기 위해 키워드를 사용합니다. 가장 자주 사용되는 것들은 다음과 같습니다:`)
};

const ja_guide_json_schema_s2_p1 = /** @type {(inputs: Guide_Json_Schema_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schemaはキーワードを使用して制約を定義します。以下は最もよく使用されるものです：`)
};

/**
* | output |
* | --- |
* | "JSON Schema uses keywords to define constraints. Here are the most commonly used ones:" |
*
* @param {Guide_Json_Schema_S2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_p1 = /** @type {((inputs?: Guide_Json_Schema_S2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_p1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_p1(inputs)
	return ja_guide_json_schema_s2_p1(inputs)
});